import { apiPostRequest } from './apiClient';

/**
 * CSRFトークンをクッキーから取得する関数
 * @returns CSRFトークンまたは空文字列
 */
export const getCsrfToken = (): string => {
    try {
        const cookies = document.cookie.split(';');

        for (const cookie of cookies) {
            const [name, value] = cookie.trim().split('=');

            if (name === 'XSRF-TOKEN') {
                return decodeURIComponent(value);
            }
        }

        return '';
    } catch (error) {
        return '';
    }
};

/**
 * CSRFトークンを初期化（明示的に取得）する
 * ログイン直後など、CSRFトークンがまだ設定されていない場合に使用
 */
export const initializeCsrfToken = async (): Promise<string> => {
    try {
        // トークン初期化のためにPOSTリクエストを送信
        // responseは利用しないが自動的にクッキーにCSRFトークンが設定される
        await fetch('/api/auth/csrf-token', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        });

        // トークンがクッキーに設定されるまで少し待機
        await new Promise((resolve) => setTimeout(resolve, 100));

        // トークンを取得して返す
        return getCsrfToken();
    } catch (error) {
        return '';
    }
};

// セッションチェック
export const checkSession = async (): Promise<void> => {
    try {
        const response = await apiPostRequest('/api/auth/check-session', {});

        // 正常なレスポンス（200 OK）以外の場合
        if (response?.status !== 200) {
            // セッションが無効、またはサーバーエラーの場合、セッション切れとしてログインページにリダイレクト
            window.location.replace('/login?session_expired=true');
            return;
        }

        // 200 OKの場合は認証成功
        return;
    } catch (error) {
        // サーバーエラーとしてリダイレクト（replace()を使用）
        window.location.replace('/login?session_expired=true');
        return;
    }
};
